/** Shared document templates cannot contain private profile records. */
export function assertDocumentData(value: unknown): void {
  const visit = (item: unknown, depth: number): void => {
    if (depth > 100) throw new Error("Document data is too deeply nested");
    if (!item || typeof item !== "object") return;
    for (const [key, child] of Object.entries(item)) {
      const name = key
        .replace(/^.*\./, "")
        .replace(/[\[\]]/g, "")
        .toUpperCase();
      if (
        ([
          "ESM_GLOBAL_FORMS_PROFILE",
          "ESM_GLOBAL_FORMS_DATA",
          "ESM_GLOBAL_FORMS_USERS",
        ].includes(name) &&
          Array.isArray(child) &&
          child.length > 0) ||
        (key === "_proofGlobalFormValues" && child)
      )
        throw new Error(
          "Private profile records are not supported in document templates. Use Configuration > Global Profiles.",
        );
      visit(child, depth + 1);
    }
  };
  visit(value, 0);
}
